import { DateTime } from 'luxon';
import {
  CREATE_BOARD_CARD_TEMPLATE,
  DELETE_BOARD_CARD_TEMPLATE,
  GET_BOARD_CARD_TEMPLATES,
  UPDATE_BOARD_CARD_TEMPLATE,
  GET_BOARDS,
  GET_BOARDS_FOR_DROPDOWN,
  CREATE_BOARD,
  GET_BOARD_DETAILS,
  GET_BOARD_PERMISSIONS,
  GET_BOARD_CARDS_FOR_DROPDOWN,
  CREATE_CARD,
  MOVE_CARD,
  GET_BOARD_CARD_FILES,
  UPDATE_CARD,
  DELETE_CARD,
  TOGGLE_BOARD_LOCK,
  GET_BOARD_CARD_NOTES,
  ADD_BOARD_CARD_NOTE,
  UPDATE_BOARD_CARD_NOTE,
  DELETE_BOARD_CARD_NOTE,
  DELETE_BOARD,
  UPDATE_BOARD,
  UPDATE_CARD_TASKS,
  GET_CARD_LINKS,
  GET_CARDS_BY_LINK,
  GET_MY_CARD_TAGS,
  MARK_CARD_TAGS_AS_READ,
  GET_CARD_ATTACHMENTS,
  GET_CARD_EVENTS,
  REORDER_CARDS,
  SWITCH_BOARD_VIEW_TYPE,
  CLOSE_CARD_DRAWER,
  OPEN_CARD_DRAWER,
  GET_BOARDS_LIBRARY,
  GET_BOARDS_LIBRARY_TEMPLATE,
  IMPORT_FROM_BOARD_LIBRARY,
  GET_CARD_EMAILS,
  GET_CARD_EMAIL_THREAD,
  GET_CARD_EMAIL_FILES,
  SET_BOARD_TARGET_CARD,
  OPEN_FORM_MAP_DRAWER,
  CLOSE_FORM_MAP_DRAWER,
  OPEN_FORM_DRAWER,
  CLOSE_FORM_DRAWER,
  DELETE_BOARD_FORM_MAPPING,
  UPDATE_BOARD_FORM_MAPPING,
  CREATE_BOARD_FORM_MAPPING,
  GET_BOARD_FORM_MAPPINGS,
  CREATE_BOARD_TEMPLATE,
  UPDATE_BOARD_TEMPLATE,
  GET_BOARD_TEMPLATES,
  DELETE_BOARD_TEMPLATE,
  MASS_UPLOAD_CARDS,
  GET_CARD_BY_ID,
  CLEAR_SELECTED_CARD,
  SWITCH_BOARD_GANTT_VIEW_TYPE,
  SWITCH_BOARD_GANTT_ZOOM_SCALE,
  GET_CARD_SNAPSHOTS,
  GET_CARD_SNAPSHOT_BY_ID,
  SET_SNAPSHOT_CARD_DATA,
  CLEAR_SNAPSHOT_CARD_DATA,
  SET_BOARD_FILTERS,
  UPDATE_BOARD_FILTERS,
  GET_BOARD_FILTER_VIEWS,
  CREATE_BOARD_FILTER_VIEW,
  UPDATE_BOARD_FILTER_VIEW,
  DELETE_BOARD_FILTER_VIEW,
  FAVOURITE_BOARD_FILTER_VIEW,
  CLEAR_CARD_SHADOW,
  SET_CARD_DRAGGING,
  GET_ALL_BOARDS_DETAILS,
  GET_BOARD_STATUSES,
  GET_BOARD_COLORS,
  SET_FILTERED_CARD_IDS,
  GET_SHORT_LIST,
  GET_SHORT_LISTS,
  CREATE_SHORT_LIST,
  UPDATE_SHORT_LIST,
  DELETE_SHORT_LIST,
  CREATE_SHORT_LIST_CATEGORY,
  UPDATE_SHORT_LIST_CATEGORY,
  DELETE_SHORT_LIST_CATEGORY,
  CREATE_SHORT_LIST_ITEM,
  UPDATE_SHORT_LIST_ITEM,
  DELETE_SHORT_LIST_ITEM,
  ADD_SHORT_LIST_PERMISSION,
  UPDATE_SHORT_LIST_PERMISSION,
  DELETE_SHORT_LIST_PERMISSION,
  ADD_SHORT_LIST_CUSTOM_ITEM,
  REORDER_SHORT_LIST_CATEGORIES,
  REORDER_SHORT_LIST_ITEMS,
  OPEN_SHORT_LIST_DRAWER,
  CLOSE_SHORT_LIST_DRAWER,
  COLLAPSE_ALL_BOARD_SECTIONS,
  EXPAND_ALL_BOARD_SECTIONS,
  TOGGLE_CARD_WORK_COMPLETION,
  DELETE_USER_FROM_CARD_WORK_COMPLETION,
} from '../../state/actionTypes';
import Analytics from '../../helpers/Analytics';
import BoardService from './boards.service';
import { counters, counterWasRecentlyCalled } from '../../helpers/counters';

import { reportSlowRequest } from '../../helpers/devHelpers';
import { setStoredBoardCardSort } from '../boards.helpers';

const {
  boards: boardCounters,
} = counters;

export const getBoardLibrary = () => async (dispatch) => {
  const { data } = await BoardService.getLibrary();
  if (!data) return false;
  dispatch({
    type: GET_BOARDS_LIBRARY,
    payload: {
      library: data,
    },
  });
  return true;
};

export const getBoardLibraryTemplate = (key) => async (dispatch) => {
  const { data } = await BoardService.getBoardLibraryTemplate(key);
  if (!data) return false;
  dispatch({
    type: GET_BOARDS_LIBRARY_TEMPLATE,
    payload: {
      templateData: data,
      key,
    },
  });
  return true;
};

export const importFromBoardLibrary = (payload) => async (dispatch) => {
  const { data } = await BoardService.importFromLibrary(payload);
  if (!data) return false;
  dispatch({
    type: IMPORT_FROM_BOARD_LIBRARY,
    payload: data,
  });
  return true;
};

export const createBoardCardTemplate = (payload) => async (dispatch) => {
  Analytics.track('BoardCardTemplate/Create');
  const { data } = await BoardService.createBoardCardTempates(payload);
  if (!data) return false;
  dispatch({
    type: CREATE_BOARD_CARD_TEMPLATE,
    payload: {
      newCardTemplate: data,
    },
  });
  return true;
};

export const getBoardCardTemplates = (payload) => async (dispatch) => {
  const { data: boardCardTemplates } = await BoardService.getBoardCardTemplates(payload);
  if (!boardCardTemplates) return false;
  dispatch({
    type: GET_BOARD_CARD_TEMPLATES,
    payload: {
      boardCardTemplates,
    },
  });
  return true;
};

export const deleteBoardCardTemplate = (id, password) => async (dispatch) => {
  Analytics.track('BoardCardTemplate/Delete');
  const { data } = await BoardService.deleteCardTemplate(id, password);
  if (!data) return false;
  dispatch({
    type: DELETE_BOARD_CARD_TEMPLATE,
    payload: {
      cardTemplateId: id,
    },
  });
  return true;
};

export const updateBoardCardTemplate = (id, payload) => async (dispatch) => {
  Analytics.track('BoardCardTemplate/Update');
  const { data } = await BoardService.updateBoardCardTemplate(id, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_BOARD_CARD_TEMPLATE,
    payload: {
      id,
      newData: payload,
    },
  });
  return true;
};

export const getBoards = () => async (dispatch) => {
  if (counterWasRecentlyCalled('boards.getBoards')) return true;
  const { data: boards } = await BoardService.getBoards();
  boardCounters.getBoards = DateTime.local();
  if (!boards) {
    boardCounters.getBoards = null;
    return false;
  }
  dispatch({
    type: GET_BOARDS,
    payload: {
      boards,
    },
  });
  return true;
};

export const getBoardsForDropdown = () => async (dispatch) => {
  if (counterWasRecentlyCalled('boards.getBoardsForDropdown')) return true;
  const { data: boards } = await BoardService.getBoardsForDropdown();
  boardCounters.getBoardsForDropdown = DateTime.local();
  if (!boards) {
    boardCounters.getBoardsForDropdown = null;
    return false;
  }
  dispatch({
    type: GET_BOARDS_FOR_DROPDOWN,
    payload: {
      boards,
    },
  });
  return true;
};

export const createBoard = (payload) => async (dispatch) => {
  Analytics.track('Board/Create');
  const { data: newBoard } = await BoardService.createBoard(payload);
  if (!newBoard) return false;
  dispatch({
    type: CREATE_BOARD,
    payload: {
      newBoard,
    },
  });
  return true;
};

export const updateBoard = (id, payload) => async (dispatch) => {
  Analytics.track('Board/Update');
  const {
    data: {
      statuses: newStatuses,
      colors: newColors,
      cards: updatedCards,
      cardTaskUpdates,
      divisions: newDivisions,
    },
  } = await BoardService.updateBoard(id, payload);
  if (!newStatuses) return false;
  dispatch({
    type: UPDATE_BOARD,
    payload: {
      id,
      newData: newDivisions ? { ...payload, divisions: newDivisions } : payload,
      newStatuses,
      newColors,
      updatedCards,
    },
  });
  if (cardTaskUpdates) {
    dispatch({
      type: UPDATE_CARD_TASKS,
      payload: { updates: cardTaskUpdates },
    });
  }
  return true;
};

export const deleteBoard = (id, password) => async (dispatch) => {
  Analytics.track('Board/Delete');
  const { data: newBoard } = await BoardService.deleteBoard(id, password);
  if (!newBoard) return false;
  dispatch({
    type: DELETE_BOARD,
    payload: {
      id,
    },
  });
  return true;
};

export const toggleBoardLock = (id, isLocked, pin) => async (dispatch) => {
  const { data } = await BoardService.toggleBoardLock(id, isLocked, pin);
  if (!data) return false;
  dispatch({
    type: TOGGLE_BOARD_LOCK,
    payload: {
      id,
      isLocked,
    },
  });
  return true;
};

export const getBoardDetails = (id, shouldUpdateSelectedBoard = true) => async (dispatch) => {
  const { data: boardDetails } = await BoardService.getBoardDetails(id, shouldUpdateSelectedBoard);
  if (!boardDetails) return false;
  dispatch({
    type: GET_BOARD_DETAILS,
    payload: {
      boardId: id,
      boardDetails,
      shouldUpdateSelectedBoard,
    },
  });
  return true;
};

export const getBoardPermissions = (boardId) => async (dispatch) => {
  const { data: users } = await BoardService.getBoardPermissions(boardId);
  if (!users) return false;
  dispatch({
    type: GET_BOARD_PERMISSIONS,
    payload: {
      users,
    },
  });
  return true;
};

export const getBoardCardsForDropdown = (boardIds) => async (dispatch) => {
  const { data: cardsData } = await BoardService.getBoardCardsForDropdown(boardIds);
  if (!cardsData) return false;
  dispatch({
    type: GET_BOARD_CARDS_FOR_DROPDOWN,
    payload: {
      cardsData,
    },
  });
  return true;
};

export const getBoardCardFiles = (id) => async (dispatch) => {
  const { data: fileMap } = await BoardService.getBoardCardFiles(id);
  if (!fileMap) return false;
  dispatch({
    type: GET_BOARD_CARD_FILES,
    payload: {
      id,
      fileMap,
    },
  });
  return true;
};

export const getCardById = (id) => async (dispatch) => {
  Analytics.track('BoardCard/Create');
  const start = Date.now();
  const { data: card } = await BoardService.getCardById(id);
  reportSlowRequest({
    startTime: start,
    requestLabel: 'getCardById',
    metadata: { id },
  });
  if (!card) return false;
  dispatch({
    type: GET_CARD_BY_ID,
    payload: {
      card,
    },
  });
  return true;
};

export const clearSelectedCard = () => ({
  type: CLEAR_SELECTED_CARD,
});

export const createCard = (payload) => async (dispatch) => {
  Analytics.track('BoardCard/Create');
  const { data: newCard } = await BoardService.createCard(payload);
  if (!newCard) return false;
  dispatch({
    type: CREATE_CARD,
    payload: {
      newCard,
    },
  });
  return true;
};

export const uploadCards = (payload) => async (dispatch) => {
  Analytics.track('BoardCard/Upload');
  const { data } = await BoardService.massUpload(payload);
  if (!data) return false;
  dispatch({
    type: MASS_UPLOAD_CARDS,
    payload: {
      newCards: data,
    },
  });
  return true;
};

export const updateCard = (id, payload) => async (dispatch) => {
  Analytics.track('BoardCard/Update');
  const { data: newData } = await BoardService.updateCard(id, payload);
  if (!newData) return false;
  dispatch({
    type: UPDATE_CARD,
    payload: {
      id,
      newData,
      addedUsers: payload.addedUsers,
      removedUsers: payload.removedUsers,
    },
  });
  return true;
};

export const deleteCard = (id) => async (dispatch) => {
  Analytics.track('BoardCard/Delete');
  const { data } = await BoardService.deleteCard(id);
  if (!data) return false;
  dispatch({
    type: DELETE_CARD,
    payload: {
      id,
    },
  });
  return true;
};

export const getCardEvents = (id) => async (dispatch) => {
  const { data: events } = await BoardService.getCardEvents(id);
  if (!events) return false;
  dispatch({
    type: GET_CARD_EVENTS,
    payload: {
      id,
      events,
    },
  });
  return true;
};

export const getCardAttachments = (id) => async (dispatch) => {
  const { data } = await BoardService.getCardAttachments(id);
  if (!data) return false;
  dispatch({
    type: GET_CARD_ATTACHMENTS,
    payload: {
      cardAttachments: data,
    },
  });
  return true;
};

export const getCardEmails = (id) => async (dispatch) => {
  const { data: emails } = await BoardService.getCardEmails(id);
  if (!emails) return false;
  dispatch({
    type: GET_CARD_EMAILS,
    payload: {
      id,
      emails,
    },
  });
  return true;
};

export const getCardEmailThread = (threadId) => async (dispatch) => {
  const { data: thread } = await BoardService.getCardEmailThread(threadId);
  if (!thread) return false;
  dispatch({
    type: GET_CARD_EMAIL_THREAD,
    payload: {
      threadId,
      thread,
    },
  });
  return true;
};

export const getCardEmailFile = ({ threadId, file }) => async (dispatch) => {
  const { data: fullFile } = await BoardService.getCardEmailFile({ file, threadId });
  if (!fullFile) return false;
  dispatch({
    type: GET_CARD_EMAIL_FILES,
    payload: {
      file,
      fullFile,
    },
  });
  return true;
};

export const getCardNotes = (id) => async (dispatch) => {
  const { data } = await BoardService.getCardNotes(id);
  if (!data) return false;
  const { notes, fileMap } = data;
  dispatch({
    type: GET_BOARD_CARD_NOTES,
    payload: {
      id,
      notes,
      fileMap,
    },
  });
  return true;
};

export const addCardNote = ({
  id, text, tags, files,
}) => async (dispatch) => {
  const { data: newNote } = await BoardService.addCardNote({
    id, text, tags, files,
  });
  if (!newNote) return false;
  dispatch({
    type: ADD_BOARD_CARD_NOTE,
    payload: newNote,
  });
  return true;
};

export const updateCardNote = ({
  id, noteId, text, tags, files, removedFileIds,
}) => async (dispatch) => {
  const { data: updatedNote } = await BoardService.updateCardNote({
    id, noteId, text, tags, files, removedFileIds,
  });
  if (!updatedNote) return false;
  dispatch({
    type: UPDATE_BOARD_CARD_NOTE,
    payload: updatedNote,
  });
  return true;
};

export const deleteCardNote = ({
  id, noteId,
}) => async (dispatch) => {
  const { data } = await BoardService.deleteCardNote({ id, noteId });
  if (!data) return false;
  dispatch({
    type: DELETE_BOARD_CARD_NOTE,
    payload: {
      cardId: id,
      noteId,
    },
  });
  return true;
};

export const getCardLinks = () => async (dispatch) => {
  const { data: cardLinks } = await BoardService.getCardLinks();
  if (!cardLinks) return false;
  dispatch({
    type: GET_CARD_LINKS,
    payload: {
      cardLinks,
    },
  });
  return true;
};

export const getCardsByLink = (linkType, linkId) => async (dispatch) => {
  const { data: cardUserMap } = await BoardService.getCardsByLink(linkType, linkId);
  if (!cardUserMap) return false;
  dispatch({
    type: GET_CARDS_BY_LINK,
    payload: {
      cardUserMap,
    },
  });
  return true;
};

export const getMyCardTags = ({ hasRead = false } = {}) => async (dispatch) => {
  const { data: myCardTags } = await BoardService.getMyCardTags(hasRead);
  if (!myCardTags) return false;
  dispatch({
    type: GET_MY_CARD_TAGS,
    payload: {
      myCardTags,
      hasRead,
    },
  });
  return true;
};

export const markCardTagsAsRead = (noteIds) => async (dispatch) => {
  const { data } = await BoardService.markCardTagsAsRead(noteIds);
  if (!data) return false;
  dispatch({
    type: MARK_CARD_TAGS_AS_READ,
    payload: {
      noteIds,
    },
  });
  return true;
};

export const reorderCards = ({ type, field }) => (dispatch, getState) => {
  const { boards: { selectedBoard } } = getState();
  const boardId = selectedBoard?.id;
  if (boardId) {
    setStoredBoardCardSort(boardId, { type, field });
  }
  dispatch({
    type: REORDER_CARDS,
    payload: {
      type,
      field,
    },
  });
};

export const openCardDrawer = (drawerConfig) => ({
  type: OPEN_CARD_DRAWER,
  payload: {
    drawerConfig,
  },
});

export const openBoardCardFromColumnClick = ({
  cardId,
  boardId,
  onShortList,
  onForm,
  isLocked,
} = {}) => async (dispatch) => {
  if (!cardId || !boardId) return;
  await dispatch(getBoardDetails(boardId));
  await dispatch(getBoardPermissions(boardId));
  dispatch(openCardDrawer({
    selectedCardId: cardId,
    ...(onShortList ? { onShortList } : {}),
    ...(onForm ? { onForm } : {}),
    ...(isLocked != null ? { isLocked } : {}),
  }));
};

export const closeCardDrawer = () => ({
  type: CLOSE_CARD_DRAWER,
});

export const openFormMapDrawer = (drawerConfig) => ({
  type: OPEN_FORM_MAP_DRAWER,
  payload: {
    drawerConfig,
  },
});

export const closeFormMapDrawer = () => ({
  type: CLOSE_FORM_MAP_DRAWER,
});

export const openFormDrawer = (drawerConfig) => ({
  type: OPEN_FORM_DRAWER,
  payload: {
    drawerConfig,
  },
});

export const closeFormDrawer = () => ({
  type: CLOSE_FORM_DRAWER,
});

export const openShortListDrawer = (drawerConfig) => ({
  type: OPEN_SHORT_LIST_DRAWER,
  payload: {
    drawerConfig,
  },
});

export const closeShortListDrawer = () => ({
  type: CLOSE_SHORT_LIST_DRAWER,
});

export const switchViewType = (viewType) => {
  window.localStorage.setItem('boardViewType', viewType);

  return {
    type: SWITCH_BOARD_VIEW_TYPE,
    payload: {
      viewType,
    },
  };
};

export const switchGanttViewType = (ganttViewType) => {
  window.localStorage.setItem('boardGanttViewType', ganttViewType);

  return {
    type: SWITCH_BOARD_GANTT_VIEW_TYPE,
    payload: {
      ganttViewType,
    },
  };
};

export const switchGanttZoomScale = (ganttZoomScale) => {
  window.localStorage.setItem('boardGanttZoomScale', ganttZoomScale);

  return {
    type: SWITCH_BOARD_GANTT_ZOOM_SCALE,
    payload: {
      ganttZoomScale,
    },
  };
};

export const collapseAllBoardSections = () => ({
  type: COLLAPSE_ALL_BOARD_SECTIONS,
});

export const expandAllBoardSections = () => ({
  type: EXPAND_ALL_BOARD_SECTIONS,
});

export const setBoardTargetCard = (payload) => ({
  type: SET_BOARD_TARGET_CARD,
  payload,
});

export const setBoardFilters = (filters) => ({
  type: SET_BOARD_FILTERS,
  payload: { filters },
});

export const updateBoardFilters = (filters) => ({
  type: UPDATE_BOARD_FILTERS,
  payload: { filters },
});

export const getBoardFilterViews = (boardId) => async (dispatch) => {
  const { data } = await BoardService.getBoardFilterViews(boardId);
  if (!data) return false;
  dispatch({
    type: GET_BOARD_FILTER_VIEWS,
    payload: {
      filterViews: data,
    },
  });
  return true;
};

export const createBoardFilterView = (boardId, payload) => async (dispatch) => {
  const {
    data: {
      newFilterView,
      filterViews,
    } = {},
  } = await BoardService.createBoardFilterView(boardId, payload);
  if (!newFilterView) return false;
  dispatch({
    type: CREATE_BOARD_FILTER_VIEW,
    payload: {
      filterViews,
    },
  });
  return newFilterView;
};

export const updateBoardFilterView = (filterViewId, payload) => async (dispatch) => {
  const { data } = await BoardService.updateBoardFilterView(filterViewId, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_BOARD_FILTER_VIEW,
    payload: {
      filterViews: data,
    },
  });
  return true;
};

export const deleteBoardFilterView = (filterViewId) => async (dispatch) => {
  const { data } = await BoardService.deleteBoardFilterView(filterViewId);
  if (!data) return false;
  dispatch({
    type: DELETE_BOARD_FILTER_VIEW,
    payload: {
      filterViews: data,
    },
  });
  return true;
};

export const favouriteBoardFilterView = (filterViewId, isFavourite) => async (dispatch) => {
  const { data } = await BoardService.favouriteBoardFilterView(filterViewId, isFavourite);
  if (!data) return false;
  dispatch({
    type: FAVOURITE_BOARD_FILTER_VIEW,
    payload: {
      filterViews: data,
    },
  });
  return true;
};

export const moveCard = (id, payload) => async (dispatch) => {
  const {
    boardId,
    destinationId,
    destinationIndex,
    sourceId,
    sourceIndex,
  } = payload;
  // Optimistically move card
  dispatch({
    type: MOVE_CARD,
    payload: {
      id,
      ...payload,
    },
  });
  const { data } = await BoardService.moveCard(id, {
    boardId,
    sourceId,
    sourceIndex,
    destinationId,
    destinationIndex,
  });
  if (!data) {
    // Move failed to persist in backend, revert
    dispatch({
      type: MOVE_CARD,
      payload: {
        id,
        ...payload,
        destinationId: sourceId,
        destinationIndex: sourceIndex,
        sourceId: destinationId,
        sourceIndex: destinationIndex,
      },
    });
    return false;
  }
  return true;
};

export const getFormMappings = (boardId) => async (dispatch) => {
  const { data } = await BoardService.getFormMappings('boards', boardId);
  if (!data) return false;
  dispatch({
    type: GET_BOARD_FORM_MAPPINGS,
    payload: {
      formMappings: data,
    },
  });
  return true;
};

export const getBoardStatuses = () => async (dispatch) => {
  const { data } = await BoardService.getBoardStatuses();
  if (!data) return false;
  dispatch({
    type: GET_BOARD_STATUSES,
    payload: {
      boardStatuses: data,
    },
  });
  return true;
};

export const getBoardColors = () => async (dispatch) => {
  const { data } = await BoardService.getBoardColors();
  if (!data) return false;
  dispatch({
    type: GET_BOARD_COLORS,
    payload: {
      boardColors: data,
    },
  });
  return true;
};

export const createFormMapping = (payload) => async (dispatch) => {
  Analytics.track('BoardFormMapping/Create');
  const { data } = await BoardService.createFormMapping('boards', payload);
  if (!data) return false;
  dispatch({
    type: CREATE_BOARD_FORM_MAPPING,
    payload: {
      newMapping: data,
    },
  });
  return true;
};

export const updateFormMapping = (id, payload) => async (dispatch) => {
  Analytics.track('BoardFormMapping/Update');
  const { data } = await BoardService.updateFormMapping('boards', id, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_BOARD_FORM_MAPPING,
    payload: {
      id,
      newData: payload,
    },
  });
  return true;
};

export const deleteFormMapping = (id) => async (dispatch) => {
  Analytics.track('BoardFormMapping/Delete');
  const { data } = await BoardService.deleteFormMapping('boards', id);
  if (!data) return false;
  dispatch({
    type: DELETE_BOARD_FORM_MAPPING,
    payload: {
      mappingId: id,
    },
  });
  return true;
};

export const createBoardTemplate = (payload) => async (dispatch) => {
  const { data: { template, card } = {} } = await BoardService.createBoardTemplate(payload);
  if (!template) return false;
  dispatch({
    type: CREATE_BOARD_TEMPLATE,
    payload: {
      boardTemplate: template,
    },
  });
  if (card) {
    dispatch({
      type: CREATE_BOARD_CARD_TEMPLATE,
      payload: {
        newCardTemplate: card,
      },
    });
  }
  return true;
};

export const updateBoardTemplate = (id, payload) => async (dispatch) => {
  const { data: { template, card } = {} } = await BoardService.updateBoardTemplate(id, payload);
  if (!template) return false;
  dispatch({
    type: UPDATE_BOARD_TEMPLATE,
    payload: {
      id,
      boardTemplate: template,
    },
  });
  if (card) {
    dispatch({
      type: CREATE_BOARD_CARD_TEMPLATE,
      payload: {
        newCardTemplate: card,
      },
    });
  }
  return true;
};

export const getBoardTemplates = () => async (dispatch) => {
  const { data: boardTemplates } = await BoardService.getBoardTemplates();
  if (!boardTemplates) return false;
  dispatch({
    type: GET_BOARD_TEMPLATES,
    payload: {
      boardTemplates,
    },
  });
  return true;
};

export const deleteBoardTemplate = (id) => async (dispatch) => {
  const { data } = await BoardService.deleteBoardTemplate(id);
  if (!data) return false;
  dispatch({
    type: DELETE_BOARD_TEMPLATE,
    payload: {
      id,
    },
  });
  return true;
};

export const getCardSnapshots = (cardId) => async (dispatch) => {
  const { data } = await BoardService.getCardSnapshots(cardId);
  if (!data) return false;
  dispatch({
    type: GET_CARD_SNAPSHOTS,
    payload: {
      cardId,
      snapshots: data,
    },
  });
  return true;
};

export const getCardSnapshotById = (cardId, snapshotId) => async (dispatch) => {
  const { data } = await BoardService.getCardSnapshotById(cardId, snapshotId);
  if (!data) return false;
  dispatch({
    type: GET_CARD_SNAPSHOT_BY_ID,
    payload: { cardId, snapshot: data },
  });
  return data;
};

export const clearShadow = (boardId, cardId) => async (dispatch) => {
  const { data } = await BoardService.clearShadow(boardId, cardId);
  if (!data) return false;
  dispatch({
    type: CLEAR_CARD_SHADOW,
    payload: {
      cardId,
      boardId,
    },
  });
  return true;
};

export const clearSnapshotCardData = () => ({
  type: CLEAR_SNAPSHOT_CARD_DATA,
});

export const setSnapshotCardData = (filteredData) => ({
  type: SET_SNAPSHOT_CARD_DATA,
  payload: {
    filteredData,
  },
});

export const setCardDragging = (isDragging, sourceId) => ({
  type: SET_CARD_DRAGGING,
  payload: {
    isDragging,
    sourceId,
  },
});

export const getAllBoardsDetails = () => async (dispatch) => {
  const { data } = await BoardService.getAllDetails();
  if (!data) return false;
  dispatch({
    type: GET_ALL_BOARDS_DETAILS,
    payload: {
      data,
    },
  });
  return true;
};

export const reassignCard = (id, payload) => async (dispatch) => {
  Analytics.track('BoardCard/Reassign');
  const { data: newData } = await BoardService.reassignCard(id, payload);
  if (!newData) return false;
  dispatch({
    type: UPDATE_CARD,
    payload: {
      id,
      addedUsers: payload.addedUsers,
      removedUsers: payload.removedUsers,
    },
  });
  return true;
};

export const refreshBoardCards = (boardId) => async (dispatch, getState) => {
  const { boards: { filters = {} } = {} } = getState();

  const hasDropdownFilters = Object.values(filters ?? {})
    .some((v) => Array.isArray(v) && v.length);

  if (!hasDropdownFilters) {
    dispatch({
      type: SET_FILTERED_CARD_IDS,
      payload: { boardId, cardIds: null },
    });
    return true;
  }

  const customFilters = Object.keys(filters).reduce((acc, key) => {
    if (
      key === 'id'
        || key === 'filterView'
        || key === 'filterViewName'
        || key === 'users'
        || key === 'link'
        || key === 'boardId'
        || !filters[key]?.length
    ) {
      return acc;
    }
    acc[key] = filters[key];
    return acc;
  }, {});

  if (Object.keys(customFilters).length === 0) {
    dispatch({
      type: SET_FILTERED_CARD_IDS,
      payload: { boardId, cardIds: null },
    });
    return true;
  }

  const {
    data: { cardIds } = {},
  } = await BoardService.fetchFilteredCardIds(boardId, customFilters);
  if (!cardIds) return false;

  dispatch({
    type: SET_FILTERED_CARD_IDS,
    payload: { boardId, cardIds },
  });
  return true;
};

export const getShortList = (shortListId) => async (dispatch) => {
  const { data } = await BoardService.getShortList(shortListId);
  if (!data) return false;
  dispatch({
    type: GET_SHORT_LIST,
    payload: { data },
  });
  return true;
};

export const getShortLists = () => async (dispatch) => {
  if (counterWasRecentlyCalled('boards.getShortLists')) return true;
  const { data } = await BoardService.getShortLists();
  boardCounters.getShortLists = DateTime.local();
  if (!data) {
    boardCounters.getShortLists = null;
    return false;
  }
  dispatch({
    type: GET_SHORT_LISTS,
    payload: { data },
  });
  return true;
};

export const createShortList = (payload) => async (dispatch) => {
  const { data } = await BoardService.createShortList(payload);
  if (!data) return false;
  dispatch({
    type: CREATE_SHORT_LIST,
    payload: { data },
  });
  return data;
};

export const updateShortList = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.updateShortList(shortListId, payload);
  if (!data) return false;
  const updatedShortList = { id: shortListId, ...payload };
  if (updatedShortList.displayFields) {
    // Reducer expects displayFields to be a string
    updatedShortList.displayFields = JSON.stringify(updatedShortList.displayFields);
  }
  dispatch({
    type: UPDATE_SHORT_LIST,
    payload: { shortList: updatedShortList },
  });
  return true;
};

export const deleteShortList = (shortListId) => async (dispatch) => {
  const { data } = await BoardService.deleteShortList(shortListId);
  if (!data) return false;
  dispatch({
    type: DELETE_SHORT_LIST,
    payload: { shortListId },
  });
  return true;
};

export const createShortListCategory = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.createShortListCategory(shortListId, payload);
  if (!data) return false;
  dispatch({
    type: CREATE_SHORT_LIST_CATEGORY,
    payload: { data },
  });
  return true;
};

export const updateShortListCategory = (shortListId, shortListCategoryId, payload) => async (dispatch) => {
  const { data } = await BoardService.updateShortListCategory(shortListId, shortListCategoryId, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_SHORT_LIST_CATEGORY,
    payload: {
      shortListCategory: { ...payload, id: shortListCategoryId },
      shortListId,
    },
  });
  return true;
};

export const deleteShortListCategory = (shortListId, shortListCategoryId) => async (dispatch) => {
  const { data } = await BoardService.deleteShortListCategory(shortListId, shortListCategoryId);
  if (!data) return false;
  dispatch({
    type: DELETE_SHORT_LIST_CATEGORY,
    payload: { shortListCategoryId, shortListId },
  });
  return true;
};

export const createShortListItem = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.createShortListItem(shortListId, payload);
  if (!data) return false;
  dispatch({
    type: CREATE_SHORT_LIST_ITEM,
    payload: { data },
  });
  return true;
};

export const updateShortListItem = (shortListId, shortListItemId, payload) => async (dispatch) => {
  const { data } = await BoardService.updateShortListItem(shortListId, shortListItemId, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_SHORT_LIST_ITEM,
    payload: {
      shortListItem: { ...payload },
      shortListId,
    },
  });
  return true;
};

export const deleteShortListItem = (shortListId, shortListItemId) => async (dispatch) => {
  const { data } = await BoardService.deleteShortListItem(shortListId, shortListItemId);
  if (!data) return false;
  dispatch({
    type: DELETE_SHORT_LIST_ITEM,
    payload: { shortListItemId, shortListId },
  });
  return true;
};

export const addShortListPermission = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.addShortListPermission(shortListId, payload);
  if (!data) return false;
  dispatch({
    type: ADD_SHORT_LIST_PERMISSION,
    payload: { data, shortListId },
  });
  return true;
};

export const updateShortListPermission = (shortListId, userId, payload) => async (dispatch) => {
  const { data } = await BoardService.updateShortListPermission(shortListId, userId, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_SHORT_LIST_PERMISSION,
    payload: { shortListPermission: payload, shortListId, userId },
  });
  return true;
};

export const deleteShortListPermission = (shortListId, userId) => async (dispatch) => {
  const { data } = await BoardService.deleteShortListPermission(shortListId, userId);
  if (!data) return false;
  dispatch({
    type: DELETE_SHORT_LIST_PERMISSION,
    payload: { userId, shortListId },
  });
  return true;
};

export const addShortListCustomItem = (cardId, payload) => async (dispatch) => {
  const { data } = await BoardService.addShortListCustomItem(cardId, payload);
  if (!data) return false;
  dispatch({
    type: ADD_SHORT_LIST_CUSTOM_ITEM,
    payload: { data },
  });
  return true;
};

export const reorderShortListCategories = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.reorderShortListCategories(shortListId, payload);
  if (!data) return false;
  dispatch({
    type: REORDER_SHORT_LIST_CATEGORIES,
    payload: { ...payload, shortListId },
  });
  return true;
};

export const reorderShortListItems = (shortListId, payload) => async (dispatch) => {
  const { data } = await BoardService.reorderShortListItems(shortListId, payload);
  if (!data) return false;
  dispatch({
    type: REORDER_SHORT_LIST_ITEMS,
    payload: { ...payload, shortListId },
  });
  return true;
};

export const toggleCardWorkCompletion = (cardId, payload) => async (dispatch) => {
  const { data } = await BoardService.toggleCardWorkCompletion(cardId, payload);
  if (!data) return false;
  dispatch({
    type: TOGGLE_CARD_WORK_COMPLETION,
    payload: { cardId, ...payload },
  });
  return true;
};

export const deleteUserFromCardWorkCompletion = (cardId, userId) => async (dispatch) => {
  const { data } = await BoardService.deleteUserFromCardWorkCompletion(cardId, userId);
  if (!data) return false;
  dispatch({
    type: DELETE_USER_FROM_CARD_WORK_COMPLETION,
    payload: { cardId, userId },
  });
  return true;
};
